import React from "react";
import ProductDetail from "./ProductDetail";
import { products } from "../data/products";

const ProductPage = () => (
  <ProductDetail product={products.allInOneWirelessPrinter} />
);

export default ProductPage;
